module.exports = __webpack_public_path__ + "static/media/icon-menu.edb6805a.svg";